import { sha3_256 } from 'js-sha3' // eslint-disable-line camelcase
import Vue from 'vue'

const trackEvent = (eventData) => {
  if (Vue.prototype.$gtm && Vue.prototype.$gtm.trackEvent) {
    Vue.prototype.$gtm.trackEvent(eventData)
  } else {
    const dataLayer = (window.dataLayer = window.dataLayer || [])
    dataLayer.push({
      ...eventData
    })
  }
  return true
}

export function webToCallEvent({method, linkUrl, storeName}) {
  const dataLayer = (window.dataLayer = window.dataLayer || [])
  dataLayer.push({
    event: 'webToCall',
    method: method,
    linkUrl: linkUrl,
    storeName: storeName || 'not available'
  })
  return true
}

export function newsletterEventObject({siteLocation, email}) {
  const hashedEmail = email ? sha3_256(email) : undefined
  return {
    event: 'newsletterSubscription',
    siteLocation: siteLocation || undefined,
    email: hashedEmail
  }
}

export function repairJourneyEvent({ stepName, stepNumber }) {
  if (!stepName || !stepNumber) return
  const dataLayer = (window.dataLayer = window.dataLayer || [])
  dataLayer.push({
    event: 'repair_journey',
    repair_journey_step_name: stepName,
    repair_journey_step_number: stepNumber
  })
}

export function storeLocatorEvent({ productName, siteLocation }) {
  trackEvent({
    event: 'storeLocator',
    productName: productName || undefined,
    siteLocation: siteLocation || undefined
  })
}

export function contactRequestObj({siteLocation, contactType, requestType, optinStatus, email}) {
  if (!siteLocation || !email) return null
  return {
    event: 'contactRequest',
    siteLocation: siteLocation,
    contactType: contactType || 'Contact form',
    requestType: requestType || siteLocation,
    optinStatus: optinStatus || false,
    emailHash: sha3_256(email)
  }
}
